import { useField } from 'formik';
import { Form, Label } from 'semantic-ui-react';

interface Props {
  placeholder: string;
  name: string;
  type?: string;
  label?: string;
  readOnly?: boolean;
  changeHandler?: (data: string) => void;
}

const MyTextInput = ({
  placeholder,
  name,
  type,
  label,
  readOnly,
  changeHandler,
}: Props) => {
  const [field, meta, helpers] = useField(name);
  const propsForField = { placeholder, name, type, label, readOnly };

  return (
    <Form.Field error={meta.touched && !!meta.error}>
      <label>{label}</label>
      <input
        {...field}
        {...propsForField}
        onChange={(e) => {
          helpers.setValue(e.target.value);
          if (changeHandler) {
            changeHandler(e.target.value);
          }
        }}
      />
      {meta.touched && meta.error ? (
        <Label basic color='red'>
          {meta.error}
        </Label>
      ) : null}
    </Form.Field>
  );
};

export default MyTextInput;
